import cdek from '@shared/assets/images/cdek.png';
import { useAppSelector } from '@shared/hooks';

import { selectMetadata } from '@src/entities/cart';

import * as st from './styles.module.scss';

export const Method = () => {
	const metadata = useAppSelector(selectMetadata);
	return (
		<div className={st.method}>
			<img className={st.method__image} src={cdek} alt="" />
			{metadata?.total_sum && <span>{metadata.total_sum / 100} ₽</span>}
		</div>
	);
};
